export default {
  dbl_create_dashboard_ai_analysis_entry_title: 'AI Analysis',
  dbl_ai_analysis_entry_new: 'NEW',
  dbl_ai_analysis_card_title: 'AI Analysis',
  dbl_ai_analysis_card_desc: 'Please confirm the ',
  dbl_ai_analysis_analysis_approach: 'analysis approach',
  dbl_ai_analysis_generating: 'AI analysis report is being generated...',
  /** Shown on AI card when the dashboard has no chart cards to analyze */
  dbl_ai_analysis_no_chart_title: 'No Chart Available',
  /** Shown on AI card when the dashboard has no chart cards to analyze */
  dbl_ai_analysis_no_chart_desc: 'Please add a chart first',
  dbl_ai_analysis_settings_title: 'AI Analysis Settings',
  dbl_ai_analysis_report_preview_title: 'Preview AI Analysis Report',
  dbl_ai_analysis_settings_content: 'Settings',
  dbl_ai_analysis_report_preview_content: 'Reports',
  dbl_ai_analysis_preview_report: 'Preview report',
  dbl_ai_analysis_back_to_settings: 'Back to settings',

  dbl_ai_analysis_settings_scope_label: 'Analysis scope',
  dbl_ai_analysis_settings_scope_all_report: 'Whole report',
  dbl_ai_analysis_settings_scope_tabs_label: 'Tabs',
  dbl_ai_analysis_settings_scope_select_at_least_one_chart: 'Select at least one chart.',
  dbl_ai_analysis_settings_approach_label: 'Analysis approach',
  dbl_ai_analysis_settings_background_label: 'Analysis background',
  dbl_ai_analysis_settings_optional: '(Optional)',
  dbl_ai_analysis_settings_custom_approach: 'Custom Insight Approach',
  dbl_ai_analysis_settings_custom_hint: 'In this input box, you can customize output requirements and analysis approach.',
  dbl_ai_analysis_settings_approach_placeholder: 'Enter analysis approach (max 50,000 chars)',
  dbl_ai_analysis_settings_background_placeholder: 'Describe the game scenario, core metrics, and anomaly rules to help the model.\nExample: mobile game retention & payment analysis - focus on Day 1 retention, ARPU, and payer conversion rate.',
  dbl_ai_analysis_settings_loading: 'Loading',
  dbl_ai_analysis_settings_load_fail: 'Load failed',
  dbl_ai_analysis_settings_no_data: 'No data',
  dbl_ai_analysis_settings_retry: 'Refresh',
  dbl_ai_analysis_settings_action_preview: 'Preview',
  dbl_ai_analysis_settings_action_save_template: 'Save as Template',
  dbl_ai_analysis_settings_action_auto_apply_next_time: 'Auto Apply Next Time',
  dbl_ai_analysis_settings_action_confirm: 'Confirm',
  dbl_ai_analysis_settings_action_cancel: 'Cancel',
  dbl_ai_analysis_template_modal_title: 'Save as Analysis Template',
  dbl_ai_analysis_template_type_label: 'Template type',
  dbl_ai_analysis_template_type_personal: 'Personal template',
  dbl_ai_analysis_template_type_game: 'Game template',
  dbl_ai_analysis_template_type_public: 'Public template',
  dbl_ai_analysis_template_name_label: 'Template name',
  dbl_ai_analysis_template_name_placeholder: 'Please enter the name',
  dbl_ai_analysis_template_name_required: 'Please enter the name',
  dbl_ai_analysis_template_name_max_length: 'Maximum length is {count} characters',
  dbl_ai_analysis_template_name_reserved:
    'Default Insight Approach is reserved for the system default. Please use another template name.',
  dbl_ai_analysis_template_name_reserved_custom:
    'Custom Insight Approach is reserved. Please use another template name.',
  dbl_ai_analysis_template_name_duplicate:
    'This name already exists. Saving will overwrite the existing template.',
  dbl_ai_analysis_template_hint_personal: 'Visible only to you; usable only in dashboards you have access to.',
  dbl_ai_analysis_template_hint_game: 'Usable by any user on any report within the current game business.',
  dbl_ai_analysis_template_hint_public: 'Usable by any user on any report across all businesses.',
  dbl_ai_analysis_template_category_forbidden: 'You do not have permission to save this template type.',
  dbl_ai_analysis_template_save_success: 'Template saved successfully',
  dbl_ai_analysis_template_save_fail: 'Failed to save template. Please try again later.',
  dbl_ai_analysis_settings_auto_apply_success: 'Saved. This configuration will be applied automatically next time.',
  dbl_ai_analysis_settings_auto_apply_fail: 'Failed to save. Please try again later.',
  dbl_ai_analysis_stream_default_query: 'Please generate key insights for the current dashboard and explain the metric changes.',
  dbl_ai_analysis_stream_send: 'Send',
  dbl_ai_analysis_stream_regenerate: 'Regenerate',
  dbl_ai_analysis_stream_stop: 'Stop',
  dbl_ai_analysis_stream_clear: 'Clear',
  dbl_ai_analysis_stream_empty: 'No streaming output yet.',
  dbl_ai_analysis_stream_parse_error: 'Failed to parse streaming payload.',
  dbl_ai_analysis_stream_state_idle: 'State: idle',
  dbl_ai_analysis_stream_state_pending: 'State: connecting',
  dbl_ai_analysis_stream_state_progressing: 'State: analyzing',
  dbl_ai_analysis_stream_state_complete: 'State: complete',
  dbl_ai_analysis_stream_state_rejected: 'State: interrupted',
  dbl_ai_analysis_filter_change_tip_prefix: 'Current report data has been updated. Click',
  dbl_ai_analysis_filter_change_tip_action: 'Refresh',
  dbl_ai_analysis_filter_change_tip_suffix: 'to regenerate insight analysis.',
  dbl_ai_analysis_stream_background_prefix: 'Business background: ',
  dbl_ai_analysis_apply_and_exit: 'Apply and Exit',
};

